'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './memberAttributeType.routes.js';
import MemAtrTypeListCtrl from './list/list.controller.js';
import MemAtrTypeViewCtrl from './view/view.controller.js';
import MemAtrTypeFormCtrl from './form/form.controller.js';

export default angular.module('georgeApp.memberAttributeType',
  [uiRouter])
  .config(routing)
  .controller('MemAtrTypeListCtrl', MemAtrTypeListCtrl)
  .controller('MemAtrTypeViewCtrl', MemAtrTypeViewCtrl)
  .controller('MemAtrTypeFormCtrl', MemAtrTypeFormCtrl)
  .name;
